import request from '@/utils/request'

export interface TimeZone {
  id: number
  zone: string
}
export function FindTimeZone(): Promise<TimeZone[]> {
  return request.get('/static/timezone')
}
